import { render, staticRenderFns } from "./SidebarAddBooking.vue?vue&type=template&id=1670d9e8"
import script from "./SidebarAddBooking.js?vue&type=script&lang=js&external"
export * from "./SidebarAddBooking.js?vue&type=script&lang=js&external"
import style0 from "./SidebarAddBooking.vue?vue&type=style&index=0&id=1670d9e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports